/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { GenerateOutputUrlResponseDto } from '../model/generateOutputUrlResponseDto';
// @ts-ignore
import { ScriptExecuteRequestDto } from '../model/scriptExecuteRequestDto';
// @ts-ignore
import { ScriptExecutionDto } from '../model/scriptExecutionDto';
// @ts-ignore
import { ScriptExecutionPageDto } from '../model/scriptExecutionPageDto';
// @ts-ignore
import { ScriptExecutionTargetDto } from '../model/scriptExecutionTargetDto';
// @ts-ignore
import { ScriptExecutionTargetPageDto } from '../model/scriptExecutionTargetPageDto';
// @ts-ignore
import { ScriptRegistryEntryDto } from '../model/scriptRegistryEntryDto';
// @ts-ignore
import { ScriptRegistryPageDto } from '../model/scriptRegistryPageDto';
// @ts-ignore
import { ScriptSyncResultDto } from '../model/scriptSyncResultDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class ScriptRunnerOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Execute a script
     * Triggers execution of a script against the specified targets.
     * @param scriptExecuteRequestDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public executeScriptV1Operator(scriptExecuteRequestDto: ScriptExecuteRequestDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ScriptExecutionDto>;
    public executeScriptV1Operator(scriptExecuteRequestDto: ScriptExecuteRequestDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScriptExecutionDto>>;
    public executeScriptV1Operator(scriptExecuteRequestDto: ScriptExecuteRequestDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScriptExecutionDto>>;
    public executeScriptV1Operator(scriptExecuteRequestDto: ScriptExecuteRequestDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (scriptExecuteRequestDto === null || scriptExecuteRequestDto === undefined) {
            throw new Error('Required parameter scriptExecuteRequestDto was null or undefined when calling executeScriptV1Operator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/script-runner/execute`;
        return this.httpClient.request<ScriptExecutionDto>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: scriptExecuteRequestDto,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generate presigned S3 output URL for a script execution
     * Generates a presigned S3 URL for downloading the output of a script execution.
     * @param scriptId Unique human-readable script identifier (e.g. aws-ebs-snapshot-cleanup)
     * @param targetCloud Target cloud provider for the execution
     * @param executionId Unique UUID of the script execution run
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generateOutputUrlV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GenerateOutputUrlResponseDto>;
    public generateOutputUrlV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GenerateOutputUrlResponseDto>>;
    public generateOutputUrlV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GenerateOutputUrlResponseDto>>;
    public generateOutputUrlV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (scriptId === null || scriptId === undefined) {
            throw new Error('Required parameter scriptId was null or undefined when calling generateOutputUrlV1Operator.');
        }
        if (targetCloud === null || targetCloud === undefined) {
            throw new Error('Required parameter targetCloud was null or undefined when calling generateOutputUrlV1Operator.');
        }
        if (executionId === null || executionId === undefined) {
            throw new Error('Required parameter executionId was null or undefined when calling generateOutputUrlV1Operator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/script-runner/scripts/${this.configuration.encodeParam({name: "scriptId", value: scriptId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/executions/${this.configuration.encodeParam({name: "targetCloud", value: targetCloud, in: "path", style: "simple", explode: false, dataType: "'AWS'", dataFormat: undefined})}/${this.configuration.encodeParam({name: "executionId", value: executionId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/generate-output-url`;
        return this.httpClient.request<GenerateOutputUrlResponseDto>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get script manifest data by ID
     * Returns a single script in the registry with its full manifest data.
     * @param scriptId Unique human-readable script identifier (e.g. aws-ebs-snapshot-cleanup)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScriptByIdV1Operator(scriptId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ScriptRegistryEntryDto>;
    public getScriptByIdV1Operator(scriptId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScriptRegistryEntryDto>>;
    public getScriptByIdV1Operator(scriptId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScriptRegistryEntryDto>>;
    public getScriptByIdV1Operator(scriptId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (scriptId === null || scriptId === undefined) {
            throw new Error('Required parameter scriptId was null or undefined when calling getScriptByIdV1Operator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/script-runner/scripts/${this.configuration.encodeParam({name: "scriptId", value: scriptId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<ScriptRegistryEntryDto>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a single execution target
     * Returns the status and data of a single execution target.
     * @param scriptId Unique human-readable script identifier (e.g. aws-ebs-snapshot-cleanup)
     * @param targetCloud Target cloud provider for the execution
     * @param executionId Unique UUID of the script execution run
     * @param targetId Sequence-generated identifier of the execution target
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScriptExecutionTargetV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, targetId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ScriptExecutionTargetDto>;
    public getScriptExecutionTargetV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, targetId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScriptExecutionTargetDto>>;
    public getScriptExecutionTargetV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, targetId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScriptExecutionTargetDto>>;
    public getScriptExecutionTargetV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, targetId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (scriptId === null || scriptId === undefined) {
            throw new Error('Required parameter scriptId was null or undefined when calling getScriptExecutionTargetV1Operator.');
        }
        if (targetCloud === null || targetCloud === undefined) {
            throw new Error('Required parameter targetCloud was null or undefined when calling getScriptExecutionTargetV1Operator.');
        }
        if (executionId === null || executionId === undefined) {
            throw new Error('Required parameter executionId was null or undefined when calling getScriptExecutionTargetV1Operator.');
        }
        if (targetId === null || targetId === undefined) {
            throw new Error('Required parameter targetId was null or undefined when calling getScriptExecutionTargetV1Operator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/script-runner/scripts/${this.configuration.encodeParam({name: "scriptId", value: scriptId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/executions/${this.configuration.encodeParam({name: "targetCloud", value: targetCloud, in: "path", style: "simple", explode: false, dataType: "'AWS'", dataFormat: undefined})}/${this.configuration.encodeParam({name: "executionId", value: executionId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/targets/${this.configuration.encodeParam({name: "targetId", value: targetId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        return this.httpClient.request<ScriptExecutionTargetDto>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all script execution targets (global)
     * Returns a paginated list of all script execution targets across all executions.
     * @param targetCloud Filter by target cloud provider
     * @param state Filter by execution target state. Allowed values: QUEUED, IN_PROGRESS, SUCCESS, FAILED.
     * @param createdBy Filter by the user who created the record
     * @param createdAfter Filter records created after this ISO-8601 timestamp (inclusive)
     * @param createdBefore Filter records created before this ISO-8601 timestamp (inclusive)
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScriptExecutionTargetsGlobalV1Operator(targetCloud?: 'AWS', state?: 'QUEUED' | 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ScriptExecutionTargetPageDto>;
    public getScriptExecutionTargetsGlobalV1Operator(targetCloud?: 'AWS', state?: 'QUEUED' | 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScriptExecutionTargetPageDto>>;
    public getScriptExecutionTargetsGlobalV1Operator(targetCloud?: 'AWS', state?: 'QUEUED' | 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScriptExecutionTargetPageDto>>;
    public getScriptExecutionTargetsGlobalV1Operator(targetCloud?: 'AWS', state?: 'QUEUED' | 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>targetCloud, 'target-cloud');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>state, 'state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdBy, 'created-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdAfter, 'created-after');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdBefore, 'created-before');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/script-runner/script-execution-targets`;
        return this.httpClient.request<ScriptExecutionTargetPageDto>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get execution targets for a script execution
     * Returns a paginated list of execution targets for a specific execution run.
     * @param scriptId Unique human-readable script identifier (e.g. aws-ebs-snapshot-cleanup)
     * @param targetCloud Target cloud provider for the execution
     * @param executionId Unique UUID of the script execution run
     * @param state Filter by execution target state. Allowed values: QUEUED, IN_PROGRESS, SUCCESS, FAILED.
     * @param createdBy Filter by the user who created the record
     * @param createdAfter Filter records created after this ISO-8601 timestamp (inclusive)
     * @param createdBefore Filter records created before this ISO-8601 timestamp (inclusive)
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScriptExecutionTargetsV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, state?: 'QUEUED' | 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ScriptExecutionTargetPageDto>;
    public getScriptExecutionTargetsV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, state?: 'QUEUED' | 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScriptExecutionTargetPageDto>>;
    public getScriptExecutionTargetsV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, state?: 'QUEUED' | 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScriptExecutionTargetPageDto>>;
    public getScriptExecutionTargetsV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, state?: 'QUEUED' | 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (scriptId === null || scriptId === undefined) {
            throw new Error('Required parameter scriptId was null or undefined when calling getScriptExecutionTargetsV1Operator.');
        }
        if (targetCloud === null || targetCloud === undefined) {
            throw new Error('Required parameter targetCloud was null or undefined when calling getScriptExecutionTargetsV1Operator.');
        }
        if (executionId === null || executionId === undefined) {
            throw new Error('Required parameter executionId was null or undefined when calling getScriptExecutionTargetsV1Operator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>state, 'state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdBy, 'created-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdAfter, 'created-after');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdBefore, 'created-before');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/script-runner/scripts/${this.configuration.encodeParam({name: "scriptId", value: scriptId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/executions/${this.configuration.encodeParam({name: "targetCloud", value: targetCloud, in: "path", style: "simple", explode: false, dataType: "'AWS'", dataFormat: undefined})}/${this.configuration.encodeParam({name: "executionId", value: executionId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/targets`;
        return this.httpClient.request<ScriptExecutionTargetPageDto>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a single script execution
     * Returns a single script execution record. The key for a run is the composite of target-cloud and execution-id.
     * @param scriptId Unique human-readable script identifier (e.g. aws-ebs-snapshot-cleanup)
     * @param targetCloud Target cloud provider for the execution
     * @param executionId Unique UUID of the script execution run
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScriptExecutionV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ScriptExecutionDto>;
    public getScriptExecutionV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScriptExecutionDto>>;
    public getScriptExecutionV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScriptExecutionDto>>;
    public getScriptExecutionV1Operator(scriptId: string, targetCloud: 'AWS', executionId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (scriptId === null || scriptId === undefined) {
            throw new Error('Required parameter scriptId was null or undefined when calling getScriptExecutionV1Operator.');
        }
        if (targetCloud === null || targetCloud === undefined) {
            throw new Error('Required parameter targetCloud was null or undefined when calling getScriptExecutionV1Operator.');
        }
        if (executionId === null || executionId === undefined) {
            throw new Error('Required parameter executionId was null or undefined when calling getScriptExecutionV1Operator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/script-runner/scripts/${this.configuration.encodeParam({name: "scriptId", value: scriptId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/executions/${this.configuration.encodeParam({name: "targetCloud", value: targetCloud, in: "path", style: "simple", explode: false, dataType: "'AWS'", dataFormat: undefined})}/${this.configuration.encodeParam({name: "executionId", value: executionId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<ScriptExecutionDto>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all script executions (global)
     * Returns a paginated list of all script executions across all scripts.
     * @param targetCloud Filter by target cloud provider
     * @param state Filter by execution state. Allowed values: IN_PROGRESS, SUCCESS, FAILED.
     * @param createdBy Filter by the user who created the record
     * @param createdAfter Filter records created after this ISO-8601 timestamp (inclusive)
     * @param createdBefore Filter records created before this ISO-8601 timestamp (inclusive)
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScriptExecutionsGlobalV1Operator(targetCloud?: 'AWS', state?: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ScriptExecutionPageDto>;
    public getScriptExecutionsGlobalV1Operator(targetCloud?: 'AWS', state?: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScriptExecutionPageDto>>;
    public getScriptExecutionsGlobalV1Operator(targetCloud?: 'AWS', state?: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScriptExecutionPageDto>>;
    public getScriptExecutionsGlobalV1Operator(targetCloud?: 'AWS', state?: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>targetCloud, 'target-cloud');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>state, 'state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdBy, 'created-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdAfter, 'created-after');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdBefore, 'created-before');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/script-runner/script-executions`;
        return this.httpClient.request<ScriptExecutionPageDto>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get executions for a script
     * Returns a paginated list of executions for the given script.
     * @param scriptId Unique human-readable script identifier (e.g. aws-ebs-snapshot-cleanup)
     * @param targetCloud Filter by target cloud provider
     * @param state Filter by execution state. Allowed values: IN_PROGRESS, SUCCESS, FAILED.
     * @param createdBy Filter by the user who created the record
     * @param createdAfter Filter records created after this ISO-8601 timestamp (inclusive)
     * @param createdBefore Filter records created before this ISO-8601 timestamp (inclusive)
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScriptExecutionsV1Operator(scriptId: string, targetCloud?: 'AWS', state?: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ScriptExecutionPageDto>;
    public getScriptExecutionsV1Operator(scriptId: string, targetCloud?: 'AWS', state?: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScriptExecutionPageDto>>;
    public getScriptExecutionsV1Operator(scriptId: string, targetCloud?: 'AWS', state?: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScriptExecutionPageDto>>;
    public getScriptExecutionsV1Operator(scriptId: string, targetCloud?: 'AWS', state?: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED', createdBy?: string, createdAfter?: Date, createdBefore?: Date, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (scriptId === null || scriptId === undefined) {
            throw new Error('Required parameter scriptId was null or undefined when calling getScriptExecutionsV1Operator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>targetCloud, 'target-cloud');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>state, 'state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdBy, 'created-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdAfter, 'created-after');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdBefore, 'created-before');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/script-runner/scripts/${this.configuration.encodeParam({name: "scriptId", value: scriptId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/executions`;
        return this.httpClient.request<ScriptExecutionPageDto>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get list of scripts with manifest data
     * Returns a paginated list of all scripts in the registry with their full manifest data.
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScriptsV1Operator(pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ScriptRegistryPageDto>;
    public getScriptsV1Operator(pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScriptRegistryPageDto>>;
    public getScriptsV1Operator(pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScriptRegistryPageDto>>;
    public getScriptsV1Operator(pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/script-runner/scripts`;
        return this.httpClient.request<ScriptRegistryPageDto>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sync script-runner registry from admin-account storage
     * List script directories in the admin-account script-runner bucket, read each &#x60;manifest.yaml&#x60;, and upsert rows in the Service Plane script-runner registry. Registry entries not present in the bucket are soft-disabled when the bucket lists at least one script.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postSyncScriptsV1Operator(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ScriptSyncResultDto>;
    public postSyncScriptsV1Operator(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScriptSyncResultDto>>;
    public postSyncScriptsV1Operator(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScriptSyncResultDto>>;
    public postSyncScriptsV1Operator(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/script-runner/sync`;
        return this.httpClient.request<ScriptSyncResultDto>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
